import { Stack, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  icon: React.ReactNode;
  title: string;
}

/**
 * Section headline of the statistics page: small round icon badge + label.
 */
const StatisticsSectionTitle: React.FC<Props> = ({ icon, title }) => {
  const { classes } = useStyles();

  return (
    <Stack direction={'row'} alignItems={'center'} gap={'12px'} className={classes.sectionTitle}>
      <span className={classes.iconBadge}>{icon}</span>
      <Typography className={classes.titleText}>{title}</Typography>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  sectionTitle: {
    marginTop: '4px',
  },
  iconBadge: {
    width: '28px',
    height: '28px',
    minWidth: '28px',
    borderRadius: '50%',
    background: theme.palette.backgrounds.main,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  titleText: {
    fontSize: theme.typography.pxToRem(17),
    fontWeight: 500,
  },
}));

export default StatisticsSectionTitle;
